import { theme } from "@tm/utility/global";
import styled from "styled-components";

export const ResultSheet = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  box-sizing: border-box;
  width: 100%;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 10;
  background-color: ${theme.disabledGrey2};
  overflow-y: scroll;
`;

export const ResultSheetContent = styled.div`
  padding: 16px;
  padding-bottom: 100px;
`;

export const ResultModalWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 24px;
  min-height: 200px;
`;
